import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'summary-component',
    templateUrl: 'summary-component.html',
    styleUrls: ['./summary-component.scss']
})

export class SummaryComponent implements OnInit {

    @Input() profissionalInfo: any = {};
    @Input() infoUser: any = {};

    list: any[] = [
        {
            type: 'procedimentos',
            qtd: '05'
        },
        {
            type: 'resultados',
            qtd: '45'
        },
        {
            type: 'imunização',
            qtd: '05'
        },
        {
            type: 'problemas',
            qtd: '05'
        },
        {
            type: 'medicamentos',
            qtd: '05'
        },
        {
            type: 'alergias',
            qtd: '05'
        },
    ];

    constructor() {

    }

    ngOnInit() {
        console.log('ngOnInit -> SummaryComponent');
        console.log(this.infoUser);
    }
}
